import Content from '@ui/components/Content/Content';
import styles from '@ui/components/Bubble/Bubble.module.scss';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Bubble = ({ text }) => (
  <div className={classNames(styles.bubble, 'big-entrance-animation')}>
    <Content
      align="center"
      className={styles.content}
      size="sm"
      theme="contrast"
    >
      {text}
    </Content>
  </div>
);

Bubble.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Bubble;
